import bus from '@/utils/eventBus'

export default function () {
  // Event for tranfer
  bus.$on('is-transfered', values => {
    this.doLoadAll()
    this.showIsTransferred = values.show
  })

  // Event for tranfer
  bus.$on('is-delayed', values => {
    this.doLoadAll()
    this.showIsDelayed = values.show
  })

  // Event for tranfer
  bus.$on('is-scheduled', values => {
    this.doLoadAll()
    this.showIsScheduled = values.show
  })

  // Event for attended
  bus.$on('is-attended', values => {
    this.doLoadAll()
    this.showIsAttended = values.show
  })

  // Event for absent
  bus.$on('is-absent', values => {
    this.doLoadAll()
    this.showIsAbsent = values.show
  })

  // Event for canceled
  bus.$on('is-canceled', values => {
    this.doLoadAll()
    this.showIsCanceled = values.show
  })

  // Event for in attendance
  bus.$on('is-attendance', values => {
    this.doLoadAll()
    this.showIsAttendance = values.show
  })

  // Event for present
  bus.$on('is-present', values => {
    this.doLoadAll()
    this.showIsPresent = values.show
  })

  // Event for rollback
  bus.$on('is-rollback', values => {
    this.doLoadAll()
    this.showIsRollback = values.show
  })

  // Event for reverser
  bus.$on('is-reverser', values => {
    this.doLoadAll()
    this.showIsReverser = values.show
  })
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/resources/mounted.js